import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { MicroserviceTypes } from 'typings';
import { usePurchaseRequestByIdQuery } from 'api';

export const PurchaseRequestAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  const { data: purchaseRequestDetails = {} } = usePurchaseRequestByIdQuery({ id }, { skip: !id });
  const isFinalStatus = purchaseRequestDetails?.purchaseRequest?.isFinalStatus;

  return (
    <Attachments
      entityId={id}
      entityName={'PURCHASE_REQUEST'}
      service={'wrd' as MicroserviceTypes}
      hasAccessToWrite={hasAccess(PERMISSIONS.purchaseRequests.attachment.write) && !isFinalStatus}
      hasAccessToDelete={hasAccess(PERMISSIONS.purchaseRequests.attachment.delete) && !isFinalStatus}
    />
  );
});
